module.exports = __webpack_public_path__ + "static/media/bg_page68.b3a205bb.png";